// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../sfd-v2/node_modules/css-loader/dist/cjs.js!../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epx-dmn-issues {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  background: var(--epx-dmn-panel-bg);
  border-top: 1px solid var(--epx-dmn-panel-border);
  max-height: 220px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.epx-dmn-issues__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid var(--epx-dmn-panel-border);
  background: var(--epx-dmn-panel-hover);
}

.epx-dmn-issues__title {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.05em;
  color: var(--epx-dmn-panel-text-muted);
}

.epx-dmn-issues__counts {
  display: flex;
  gap: 6px;
}

.epx-dmn-issues__pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--epx-dmn-grid-header-bg);
  color: var(--epx-dmn-panel-text-muted);
  border: 1px solid var(--epx-dmn-panel-border);
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
}
.epx-dmn-issues__pill:hover { background: var(--epx-dmn-panel-border); }
.epx-dmn-issues__pill--active { background: var(--epx-dmn-accent); color: #fff; border-color: var(--epx-dmn-accent); }
.epx-dmn-issues__pill--active .epx-dmn-issues__pill-count { background: rgba(255,255,255,0.3); color: #fff; }
.epx-dmn-issues__pill-count {
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-panel-text);
  border-radius: 8px;
  padding: 0 5px;
  font-size: 10px;
  font-weight: 600;
}

.epx-dmn-issues__empty {
  padding: 14px 16px;
  color: var(--epx-dmn-panel-text-muted);
  font-style: italic;
}

.epx-dmn-issues__list {
  overflow: auto;
  flex: 1;
  padding: 4px 0;
}

.epx-dmn-issues__row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-bottom: 1px solid var(--epx-dmn-grid-header-bg);
  cursor: pointer;
}
.epx-dmn-issues__row:hover { background: var(--epx-dmn-panel-hover); }

.epx-dmn-issues__sev {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: 700;
  font-size: 10px;
  color: #fff;
  flex-shrink: 0;
}
.epx-dmn-issues__sev--error   { background: var(--epx-dmn-danger); }
.epx-dmn-issues__sev--warning { background: var(--epx-dmn-warning); }

.epx-dmn-issues__msg {
  color: var(--epx-dmn-panel-text);
  flex: 1;
}

.epx-dmn-issues__meta {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 10px;
  color: var(--epx-dmn-panel-text-muted);
}
`, "",{"version":3,"sources":["webpack://./../epx-dmn/src/validation/styles.css"],"names":[],"mappings":"AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,mCAAmC;EACnC,iDAAiD;EACjD,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,sCAAsC;EACtC,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA,8BAA8B,uCAAuC,EAAE;AACvE,gCAAgC,iCAAiC,EAAE,WAAW,EAAE,mCAAmC,EAAE;AACrH,4DAA4D,iCAAiC,EAAE,WAAW,EAAE;AAC5G;EACE,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sDAAsD;EACtD,eAAe;AACjB;AACA,6BAA6B,sCAAsC,EAAE;;AAErE;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA,gCAAgC,iCAAiC,EAAE;AACnE,gCAAgC,kCAAkC,EAAE;;AAEpE;EACE,gCAAgC;EAChC,OAAO;AACT;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,sCAAsC;AACxC","sourcesContent":["@import url('../theme.css');\n\n.epx-dmn-issues {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  background: var(--epx-dmn-panel-bg);\n  border-top: 1px solid var(--epx-dmn-panel-border);\n  max-height: 220px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.epx-dmn-issues__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--epx-dmn-panel-border);\n  background: var(--epx-dmn-panel-hover);\n}\n\n.epx-dmn-issues__title {\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.05em;\n  color: var(--epx-dmn-panel-text-muted);\n}\n\n.epx-dmn-issues__counts {\n  display: flex;\n  gap: 6px;\n}\n\n.epx-dmn-issues__pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--epx-dmn-grid-header-bg);\n  color: var(--epx-dmn-panel-text-muted);\n  border: 1px solid var(--epx-dmn-panel-border);\n  border-radius: 10px;\n  padding: 2px 8px;\n  font-size: 11px;\n  cursor: pointer;\n}\n.epx-dmn-issues__pill:hover { background: var(--epx-dmn-panel-border); }\n.epx-dmn-issues__pill--active { background: var(--epx-dmn-accent); color: #fff; border-color: var(--epx-dmn-accent); }\n.epx-dmn-issues__pill--active .epx-dmn-issues__pill-count { background: rgba(255,255,255,0.3); color: #fff; }\n.epx-dmn-issues__pill-count {\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-panel-text);\n  border-radius: 8px;\n  padding: 0 5px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.epx-dmn-issues__empty {\n  padding: 14px 16px;\n  color: var(--epx-dmn-panel-text-muted);\n  font-style: italic;\n}\n\n.epx-dmn-issues__list {\n  overflow: auto;\n  flex: 1;\n  padding: 4px 0;\n}\n\n.epx-dmn-issues__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px;\n  border-bottom: 1px solid var(--epx-dmn-grid-header-bg);\n  cursor: pointer;\n}\n.epx-dmn-issues__row:hover { background: var(--epx-dmn-panel-hover); }\n\n.epx-dmn-issues__sev {\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 10px;\n  color: #fff;\n  flex-shrink: 0;\n}\n.epx-dmn-issues__sev--error   { background: var(--epx-dmn-danger); }\n.epx-dmn-issues__sev--warning { background: var(--epx-dmn-warning); }\n\n.epx-dmn-issues__msg {\n  color: var(--epx-dmn-panel-text);\n  flex: 1;\n}\n\n.epx-dmn-issues__meta {\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 10px;\n  color: var(--epx-dmn-panel-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
